import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { ArticlePath, createGuideLink, FeatureFlag, RouteName } from '@mews-commander/enums';
import { CustomerPaymentsTab, PaymentsTabActiveSegment } from '@mews-commander/modules/src/modules/payment';
import { MewsTeam, RouteType } from '@mews/enums';
import { useFeatureFlag } from '@mews/framework';

const Component = () => {
    const isNewCustomerPaymentTabRoutesEnabled = useFeatureFlag(FeatureFlag.newCustomerPaymentTabRoutesEnabled);
    const { accountId } = Route.useParams();

    if (isNewCustomerPaymentTabRoutesEnabled) {
        return null;
    }

    return <CustomerPaymentsTab accountId={accountId} activeSegment={PaymentsTabActiveSegment.Overview} />;
};

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Payment/Index/$accountId')({
    component: Component,
    validateSearch: z.object({ activeSegment: z.string().optional(), EnterpriseId: z.string().uuid().optional() }),
    staticData: {
        routeName: RouteName.PaymentIndex,
        owner: MewsTeam.PaymentExperience,
        type: RouteType.Frontend,
        guideLink: createGuideLink(ArticlePath.TakePayment),
    },
    beforeLoad: ({ context: { featureFlagService }, search, params }) => {
        if (!featureFlagService.hasFlag(FeatureFlag.newCustomerPaymentTabRoutesEnabled)) {
            return;
        }

        const { activeSegment, ...searchRemainder } = search;

        switch (activeSegment) {
            case PaymentsTabActiveSegment.Methods:
            case PaymentsTabActiveSegment.Requests:
            case PaymentsTabActiveSegment.Plans:
            case PaymentsTabActiveSegment.Overview:
                throw redirect({
                    to: `/$currentEnterpriseId/Payment/${activeSegment}/$accountId`,
                    params,
                    search: searchRemainder,
                });
            default:
                throw redirect({
                    to: '/$currentEnterpriseId/Payment/Overview/$accountId',
                    params,
                    search: searchRemainder,
                });
        }
    },
});
